var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal fade", attrs: { id: _vm.modalId, role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("txtActivityTitle")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("txtActivityTitle")) +
                "\n                "
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.title = $event.target.value
                }
              }
            }),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("txtActivityReference")) +
                "\n                "
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.reference,
                  expression: "reference"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.reference },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.reference = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.skipNextAutoTrigger,
                    expression: "skipNextAutoTrigger"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "skipTrigger" },
                domProps: {
                  checked: Array.isArray(_vm.skipNextAutoTrigger)
                    ? _vm._i(_vm.skipNextAutoTrigger, null) > -1
                    : _vm.skipNextAutoTrigger
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.skipNextAutoTrigger,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.skipNextAutoTrigger = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.skipNextAutoTrigger = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.skipNextAutoTrigger = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "skipTrigger" }
                },
                [_vm._v(_vm._s(_vm.$t("dutySkipNextAutoTrigger")))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnCancel")) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.createActivity }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnCreate")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }